import { GetPostsCategoryByTypeData, PostsCategoryResponse } from 'models/swagger-spring/data-contracts';
import { useQuery } from 'react-query';
import axios from '@apis/spring-client';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

export type PostsCategoryRequest = {
  language: 'KO' | 'EN';
  postsType: string;
};

const getPostsCategory = async ({ language, postsType }: PostsCategoryRequest): Promise<GetPostsCategoryByTypeData> => {
  try {
    const response = await axios.get(`/api/posts/category`, {
      params: {
        language,
        postsType,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const useGetPostsCategory = (postsType: string) => {
  const { i18n, t } = useTranslation('component');
  const language = i18n.language === 'ko' ? 'KO' : 'EN';

  return useQuery(['postsCategory', language, postsType], () =>
    getPostsCategory({
      language,
      postsType,
    }),
  );
};

export const useGetCachePostsCategoryById = (postsType: string, postsCategoryId: number) => {
  // TODO : 임시 방편이고 API에서 다 조회해오자.
  const { data } = useGetPostsCategory(postsType);
  const categoryById =
    useMemo(
      () =>
        data?.data?.reduce<{ [id: number]: PostsCategoryResponse }>(
          (result, item) => ({
            ...result,
            [item.id]: item,
          }),
          {},
        ),
      [data],
    ) || {};

  return categoryById[postsCategoryId];
};

export default useGetPostsCategory;
